module.exports = __webpack_public_path__ + "img/activityMob.ab181881.png";